import {
  OgsmWorkspace,
  type OgsmNavigation,
} from '@/components/custom/ogsm/ogsm-workspace'
import { OgsmApiContext } from '@/features/ogsm/ogsm-api'
import { OGSM_COPY } from '@/features/ogsm/ogsm-labels'
import { PORTAL_OGSM_API, usePortalOgsmAccess } from '@/hooks/use-portal-ogsm'

export interface PortalOgsmTabProps {
  companyId: string
  companyName: string
  sessionId?: string
  objectiveId?: string
  onNavigate: (next: OgsmNavigation) => void
}

/** The shared OGSM board on the portal's own routes; edit affordances still follow the backend's flags. */
export function PortalOgsmTab({
  companyId,
  companyName,
  sessionId,
  objectiveId,
  onNavigate,
}: PortalOgsmTabProps) {
  const { canEdit } = usePortalOgsmAccess()

  return (
    <OgsmApiContext.Provider value={PORTAL_OGSM_API}>
      <OgsmWorkspace
        companyId={companyId}
        companyName={companyName}
        sessionId={sessionId}
        objectiveId={objectiveId}
        onNavigate={onNavigate}
        title={OGSM_COPY.title}
        surface="portal"
        readOnlyViewer={!canEdit}
      />
    </OgsmApiContext.Provider>
  )
}
